import { logB2BEvent } from '@/utils/analytics';
import Events from '@/utils/amplitudeEvents.json';
import { ComponentPropsWithoutRef, MouseEventHandler } from 'react';
import { CustomNavLink } from '@/components/Navigation/CustomNavLink';

export const B2BNavLink = ({ children, onClick, href, ...props }: ComponentPropsWithoutRef<typeof CustomNavLink>) => {
  const label = typeof children === 'string' ? children : undefined;
  const isBookADemo = typeof href === 'string' && href.startsWith('mailto:');

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    logB2BEvent(Events.B2B_NAV_CLICK, { nav_item: label });

    if (isBookADemo) {
      logB2BEvent(Events.B2B_CONVERSION_CLICK, { conversion_type: 'book_a_demo' });
    }

    onClick?.(e);
  };

  return (
    <CustomNavLink onClick={handleClick} href={href} {...props}>
      {children}
    </CustomNavLink>
  );
};
